import React from 'react'
import { Field, reduxForm } from 'redux-form'

import { FormButtons, renderers, validations } from '../../../components'
export const CATEGORY_CHOICES = [
  { code: 'ios', text: 'iPhone / iPad / Watch / Accessories' },
  { code: 'mac', text: 'MacBook / Mac / MacPro' },
  { code: 'delivery', text: 'Delivery / Shipping' },
]
const FORM_NAME = 'SetCategoryForm'
let SetCategoryForm = ({
  handleSubmit,
  pristine,
  reset,
  submitting,
  dispatch,
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <Field
        component={renderers.renderSelectField}
        as="select"
        validate={[validations.required]}
        name={`category`}
        label="Product"
      >
        {CATEGORY_CHOICES.map((x) => {
          return (
            <option key={x.code} value={x.code}>
              {x.text}
            </option>
          )
        })}
        <option key={'ALL'} value={'ALL'}>
          ALL
        </option>
      </Field>
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}

SetCategoryForm = reduxForm({
  form: FORM_NAME,
})(SetCategoryForm)

export default SetCategoryForm
